import { render } from "./Request.vue?vue&type=template&id=5d9814b8&scoped=true&ts=true"
import script from "./Request.vue?vue&type=script&lang=ts"
export * from "./Request.vue?vue&type=script&lang=ts"

import "./Request.vue?vue&type=style&index=0&id=5d9814b8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9814b8"]])

export default __exports__